import { Carousel, Row, Col } from 'antd';
import React from 'react';
import { sliderImg } from "../../assets"
const contentStyle = {
    minHeight: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: 'transparent',
};

const App = () => (
    <div className='sliderSection'>
        <Row align='middle' justify='space-between' style={{ width: "90%", margin: "auto" }}>
            <Col xl={5} lg={24} >
                <img src={sliderImg} alt="slider" />
            </Col>
            <Col xl={14} lg={24}>
                <Carousel autoplay>
                    <div>
                        <div style={{ ...contentStyle, padding: "1rem" }}>
                            <h3>User Reviews</h3>
                            <p className='pSmall'>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odit, quidem quam? Iusto, modi cumque sequi id corrupti odit suscipit veniam veritatis illum quibusdam aperiam accusantium quam assumenda natus fugiat autem.
                            </p>
                            <p style={{ margin: "0 !important", padding: "0" }}>
                                <i>UserName</i>
                            </p>
                        </div>
                    </div>
                    <div>
                        <div style={{ ...contentStyle, padding: "1rem" }}>
                            <h3>User Reviews</h3>
                            <p className='pSmall'>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odit, quidem quam? Iusto, modi cumque sequi id corrupti odit suscipit veniam veritatis illum quibusdam aperiam accusantium quam assumenda natus fugiat autem.
                            </p>
                            <p style={{ margin: "0 !important", padding: "0" }}>
                                <i>UserName</i>
                            </p>
                        </div>
                    </div>
                    <div>
                        <div style={{ ...contentStyle, padding: "1rem" }}>
                            <h3>User Reviews</h3>
                            <p className='pSmall'>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odit, quidem quam? Iusto, modi cumque sequi id corrupti odit suscipit veniam veritatis illum quibusdam aperiam accusantium quam assumenda natus fugiat autem.
                            </p>
                            <p style={{ margin: "0 !important", padding: "0" }}>
                                <i>UserName</i>
                            </p>
                        </div>
                    </div>
                </Carousel>
            </Col>
        </Row>
    </div>

);

export default App;